import { useEffect } from 'react';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import AddCustomer from './components/AddCustomer';
import '../../styles/products.scss';

const CustomerEdit = () => {
  const { id } = useParams();
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Modifier le Client');
  }, [setTitle]);

  return (
    <div className="customer-edit-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddCustomer isEdit={true} customerId={id} />
        </Col>
      </Row>
    </div>
  );
};

export default CustomerEdit;